module.exports = __webpack_public_path__ + "static/media/IconTemplates_-70.1b1c1f5f.svg";